import { Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { handleUpdateCompany } from "../../../api/mosaic/accounts";
import { useToast } from "../../shared/Toast";
import ModalWrapper, { modalCancelButtonSx, modalSubmitButtonSx } from "../../shared/ModalWrapper";

interface IUpdateCompanyModal {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsDoneSaving: React.Dispatch<React.SetStateAction<boolean>>;
  rowData?: React.SetStateAction<any>;
}

const UpdateCompanyModal = ({
  open,
  setOpen,
  setIsDoneSaving,
  rowData,
}: IUpdateCompanyModal) => {
  const { showSuccess, showError } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState("");

  const handleClose = () => setOpen(false);

  const handleUpdateCompanyName = async () => {
    try {
      setIsLoading(true);
      await handleUpdateCompany(rowData.id, formData);
      setIsLoading(false);
      setIsDoneSaving((prev) => !prev);
      setOpen(false);
      showSuccess("Company updated successfully");
    } catch (err) {
      setIsLoading(false);
      showError("Error updating company");
      console.error(err);
    }
  };

  useEffect(() => {
    if (rowData) setFormData(rowData.name);
  }, [rowData]);

  return (
    <ModalWrapper
      open={open}
      onClose={handleClose}
      title="Update Company Name"
      actions={
        <>
          <Button variant="outlined" onClick={handleClose} sx={modalCancelButtonSx}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleUpdateCompanyName} disabled={isLoading} sx={modalSubmitButtonSx}>
            {isLoading ? "Updating..." : "Update"}
          </Button>
        </>
      }
    >
      <TextField
        fullWidth
        label="Company Name"
        variant="outlined"
        value={formData}
        onChange={(e) => setFormData(e.target.value)}
        inputProps={{ maxLength: 100 }}
      />
    </ModalWrapper>
  );
};

export default UpdateCompanyModal;
